import styled from 'styled-components';
import Rating from '@components/Rating/WithBackground';

const StyledRating = styled(Rating)`
  margin: 0;
  max-width: 52px;
  font-size: 12px;
  line-height: 1.33;
  > svg {
    height: 11px;
    width: 11px;
  }
  display: flex;
  align-items: center;
`;

export default StyledRating;
